import { useState, Fragment } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { IPresetPlanSummary } from '../../../graphql/types/queries/presetPlans';
import { PresetPlanAnswers } from './PresetPlanAnswers';
import { HoverableCard } from '../LastCourses';

export const DetailsProgramProgress = ({ plan, id }: { plan: IPresetPlanSummary; id: string; }) => {
  
  // const{ data: dataSummaries, loading: loadingSummaries } = useQuery<IGetHealthCoachVisitSummariesOutput, IGetHealthCoachVisitSummariesInput>(GET_HEALTH_COACH_VISIT_SUMMARIES_ALL)
  const [hoveredRow, setHoveredRow] = useState<string | null>(null);
  const [extendedId, setExtendedId] = useState<string | null>();

  const totalPct = plan.courses.reduce((a, b) => { return a + (b.progress || 0); }, 0) / plan.courses.length;
  return (
    <>
      <Flex alignItems={'center'} mb={4} ml={'12px'} mt={2}>
        <Text style={{ fontSize: '22px', fontWeight: 600 }}>{plan.section.name}</Text>
        <Flex ml={3} width={'180px'} backgroundColor={'#D2E2FF'} mt={1} style={{ borderRadius: '2px', overflow: 'hidden' }} height='6px'>
          <Box flex={totalPct / 100} height='100%' backgroundColor={'#0F2146'} />
        </Flex>
        <Box flex={1}></Box>
        <Text style={{ fontSize: '14px', fontWeight: 300 }}>{totalPct.toFixed(2)}% completed</Text>
      </Flex>
      {plan.courses.map(x => {
        return (
          <Fragment key={x.id}>
            <HoverableCard
              key={x.title}
              mb={3}
              style={{
                border: '1px solid #E2E2E2',
                borderRadius: '20px',
                opacity: !hoveredRow || hoveredRow === `${x.id}` ? 1 : 0.7,
                boxShadow: !hoveredRow || hoveredRow === `${x.id}` ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)'
              }}
              onClick={() => {
                if (!!extendedId && extendedId === x.id) {
                  setExtendedId(null);
                  return;
                }
                setExtendedId(x.id);
              }}
              onMouseEnter={() => setHoveredRow(`${x.id}`)}
              onMouseLeave={() => setHoveredRow(null)}>
              <Flex style={{ width: '100%', padding: '12px 12px', minHeight: '70px' }} flexDirection={['column', 'row', 'row']}>
                <Flex flex={1} alignItems={'center'}>
                  <svg style={{ transform: extendedId && extendedId === x.id ? 'rotate(90deg)' : '' }} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.39995 20C8.99995 20 8.59995 19.8 8.39995 19.6C7.79995 19 7.79995 18 8.39995 17.4L13.8 12L8.39995 6.59995C7.79995 5.99995 7.79995 4.99995 8.39995 4.39995C8.99995 3.79995 9.99995 3.79995 10.6 4.39995L17.2 10.8C17.8 11.4 17.8 12.4 17.2 13L10.6 19.4C10.2 19.8 9.79995 20 9.39995 20Z" fill='rgba(52,79,122,1)' />
                  </svg>
                  <Box style={{ width: '100px', paddingLeft: '12px', alignSelf: 'center' }}>
                    <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }}>{plan.section.name}</Text>
                  </Box>
                  <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
                  <Box flex={1} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
                    <Text style={{ fontSize: '12px' }}>{x.title}</Text>
                  </Box>
                  <Box style={{ width: '1px', background: '#E2E2E2' }} display={['none', 'initial', 'initial']}></Box>
                </Flex>
                <Box marginTop={['8px', 0, 0]} width={['initial', '150px', '150px']} paddingLeft={[0, '12px', '12px']} style={{ alignSelf: 'center' }}>
                  <Flex flexDirection={x.isComplete ? 'row' : 'column'}>
                    <Text style={{ fontSize: '12px', color: !x.isStarted ? 'rgba(52,79,122,0.6)' : 'rgba(52,79,122,1)' }}>
                      {x.isComplete ? 'completed' : !x.isStarted ? 'not started' : `${(x.progress || 0).toFixed(2)}% complete`}</Text>
                    {!x.isComplete && !!x.isStarted && (
                      <Flex width={'100%'} backgroundColor={'#E2E2E2'} mt={1} style={{ borderRadius: '2px', overflow: 'hidden' }} height='6px'>
                        <Box flex={(x.progress || 0) / 100} height='100%' backgroundColor={'#15D89D'} />
                      </Flex>
                    )}
                    {x.isComplete && (
                      <svg style={{ marginLeft: '12px' }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16V16Z" fill="#15D89D" />
                        <path d="M10.9703 4.97001C10.9632 4.97691 10.9565 4.98426 10.9503 4.99201L7.47734 9.41701L5.38434 7.32301C5.24216 7.19053 5.05412 7.1184 4.85982 7.12183C4.66551 7.12526 4.48013 7.20397 4.34272 7.34138C4.2053 7.4788 4.12659 7.66418 4.12316 7.85848C4.11974 8.05278 4.19186 8.24083 4.32434 8.38301L6.97034 11.03C7.04162 11.1012 7.1265 11.1572 7.21992 11.1949C7.31334 11.2325 7.41339 11.2509 7.51408 11.2491C7.61478 11.2472 7.71407 11.2251 7.80604 11.184C7.898 11.1429 7.98074 11.0838 8.04934 11.01L12.0413 6.02001C12.1773 5.87734 12.2516 5.6869 12.2482 5.48987C12.2449 5.29285 12.1641 5.10505 12.0234 4.9671C11.8827 4.82915 11.6933 4.75211 11.4963 4.75266C11.2992 4.7532 11.1103 4.83128 10.9703 4.97001V4.97001Z" fill="#15D89D" />
                      </svg>
                    )}
                  </Flex>
                </Box>
              </Flex>
              {extendedId && extendedId === x.id && (
                <PresetPlanAnswers courseId={x.id} patientId={id} />
              )}
            </HoverableCard>
          </Fragment>
        );
      })}
    </>
  );
};
